import React from 'react'

import styles from './container.module.scss'

export default ({ className = '', children }) => (
  <div className={[styles.container, className].join(' ').trim()}>
    {children}
  </div>
)
